import axios from "axios";


export const addUserServicePost = (body) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/User`, body);
  };


  
